import { render, staticRenderFns } from "./videoDeviceError.vue?vue&type=template&id=1c585510&scoped=true&"
import script from "./videoDeviceError.vue?vue&type=script&lang=js&"
export * from "./videoDeviceError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c585510",
  null
  
)

export default component.exports